module.exports = __webpack_public_path__ + "static/img/user_logo2.d969ee67.png";